module.exports = __webpack_public_path__ + "img/4.7d1c0f13.jpg";